export default {

    data() {
        return {
            POINTTYPE: {
                BINDEQUIP: 1,
                VIRTUALEQUIP: 2,
            }
        }
    },

}